// extracted by mini-css-extract-plugin
export default {"cycleSlide":"CycleSlide_cycleSlide__Vy1SA","info":"CycleSlide_info__3VjrV","footer":"CycleSlide_footer__1UWES"};